<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="6">
                    <ValidationProvider name="product_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('product_id')">
                            <payment-products-selectbox v-model="formData.product_id" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="period_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('period_id')">
                            <payment-periods-selectbox v-model="formData.period_id" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="installment_number" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('installment_number')">
                            <b-form-input type="number" v-model="formData.installment_number" min="1" max="12" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('date')">
                            <b-input type="date" v-model="formData.date" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="createForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    // Components
    import PaymentPeriodsSelectbox from '@/components/interactive-fields/PaymentPeriodsSelectbox';
    import PaymentProductsSelectbox from '@/components/interactive-fields/PaymentProductsSelectbox';

    // Services
    import installmentDatesService from '@/services/installmentDatesService';

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'

    export default {
        components: {
            PaymentPeriodsSelectbox,
            PaymentProductsSelectbox,

            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                formData: {
                },
                formLoading: false,
            }
        },
        methods: {
            async createForm() {
                let isValid = await this.$refs.formModalValidate.validate()

                if (isValid) {
                    this.formLoading = true

                    installmentDatesService.store(this.formData)
                        .then((response) => {
                            this.$toast.success(this.$t('api.' + response.data.message))
                            this.$emit('createFormSuccess')
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        })
                        .finally(() => {
                            this.formLoading = false
                        })
                }
            },
        }
    }
</script>

